import styled from "styled-components";
import classNames from "classnames";

import media from "../media-queries";
import { BurgerMenu } from "./burger-menu";
import { Logo } from "./logo";
import { Menu } from "./menu";

const Outer = styled.div`
  background-color: ${(props) => props.theme.colours.white};
  color: ${(props) => props.theme.colours.darkGrey};
  display: flex;
  justify-content: center;
  padding: 10px 0;
  width: 100%;
  z-index: 10;
  ${media.lg} {
    z-index: 10;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 0;
  }
`;

export const Inner = styled.div`
  max-width: ${(props) => props.theme.layout.maxWidth};
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${(props) => props.theme.layout.gutter.sm};
  ${media.md} {
    padding: 0 ${(props) => props.theme.layout.gutter.md};
  }
`;

export const Container = ({ className, children }) => {
  const outerClasses = classNames(className);
  return (
    <Outer className={outerClasses}>
      <Inner className={`container__inner`}>{children}</Inner>
    </Outer>
  );
};

const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  ${media.lg} {
    justify-content: flex-end;
  }
`;

const HidingBurgerMenu = styled(BurgerMenu)`
  display: inline-block;
  ${media.lg} {
    display: none;
  }
`;

export const LogoBar = (props) => {
  const containerClasses = classNames(`logo-bar`, props.className);
  return (
    <Container className={containerClasses}>
      <Logo />
      <ContentContainer>
        <Menu />
        <HidingBurgerMenu
          menuOpen={props.menuOpen}
          setMenuOpen={props.setMenuOpen}
        />
      </ContentContainer>
    </Container>
  );
};
